export default __webpack_public_path__ + "static/media/production-img-2.93ed3288.png";